import { render, staticRenderFns } from "./CourseConnection.vue?vue&type=template&id=b63460e2&"
import script from "./CourseConnection.vue?vue&type=script&lang=js&"
export * from "./CourseConnection.vue?vue&type=script&lang=js&"
import style0 from "./CourseConnection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports